import styled from 'styled-components';

export const DatePickerButton = styled.button`
    display: flex;
    height: 46px;
    padding: 8px 10px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border: 1px solid #D0D5DD;
    border-radius: 10px;
    background: #FFF;
    cursor: pointer;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    color: ${props => props.value ? '#101828' : '#475467'};
    transition: all 0.2s ease;
    
    &:hover {
        border-color: #98A2B3;
    }
    
    &:focus {
        outline: none;
        border-color: #17B26A;
    }
`;

export const DatePickerText = styled.span`
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    color: inherit;
`;

